// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-sonner-toast] {
	max-width: 80vw !important;
	width: max-content !important;
	word-break: break-word;
	white-space: normal;
}
`, "",{"version":3,"sources":["webpack://./../../packages/py-components/src/components/molecules/Toast/toast.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;CAC1B,6BAA6B;CAC7B,sBAAsB;CACtB,mBAAmB;AACpB","sourcesContent":["[data-sonner-toast] {\n\tmax-width: 80vw !important;\n\twidth: max-content !important;\n\tword-break: break-word;\n\twhite-space: normal;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
